/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersForDiscoverSkeleton.defs.js'
export * as $defs from './getSuggestedUsersForDiscoverSkeleton.defs.js'
